import React from 'react';
import { TranslateFunction } from '@hooks/useTranslations';
import { PaymentStatuses } from 'src/constants/paymentStatuses';
import { IMySavedDeal } from 'src/redux/user/user.duck.interface';
import useCustomRouter from '@hooks/useCustomRouter';
import routes from 'src/constants/routes';
import { CarJourneyType } from 'src/services';
import { buildParameterizedPathname } from '@utils/url.utils';

export const renderOverlay = (mySavedDeal: IMySavedDeal, t: TranslateFunction) => {
    const router = useCustomRouter();

    const unavailableVehicleRedirect = () => {
        const modelUrl = buildParameterizedPathname(routes.SELECTOR, CarJourneyType.STOCK, {
            nameplateBodyStyleSlug: mySavedDeal.fullProductConfiguration.nameplateBodyStyleSlug,
            modelId: mySavedDeal.fullProductConfiguration.model.id,
            bodyStyleId: mySavedDeal.fullProductConfiguration.bodyStyle.id,
        });
        router.push(modelUrl);
    };

    //const dealPrices: IPrices | undefined = returnPrices(prices);
    if (mySavedDeal.status === PaymentStatuses.offerExpired) {
        return (
            <div className="overlay">
                <div className="dialog">
                    <h1>{t('myaccount.myOrders.offerExpiredTitle')}</h1>
                    <img
                        alt=""
                        className="icon"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAbCAYAAABr/T8RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHESURBVHgBvVbBdcIwDJX9uCa4GzgbtBvABt2gdIK2E6SdoGWCjsAIsEnCBA2cwa6c50JSO5adB/wLJo70/SVLCoMRqIQQXKkXXArF+bJomhoSMYERYFqvNMDMru/xZw6J4JCIKssWoPXs9ADXGIFZopt0YsZY6TxT6hsSkUTcqgWQni25zbInSABLebnO82qA2KDRnBd40RqIQLTibZ6XAVIDAUq9QiSiFOPlkZjHNUFsEK06qpxMzeozaYPrZXcfT9/WNJxVv1M+ScVWbXW2YBu52/Xqtp5O150SM6ofqKZC5hjV9stHa0GYCH48lkD5DW0atRjWxX/Hzotay95fxhZUUwkSO2oTgK20HEVsTuxRGw+ilQ4SB9qgL8fS6yOg2kscaI1DxH4EVHvr2DcIPAeLgo1c4Tz3OUXi5GkTAt6Vt2K//woSE4PAWrEN5q9unTImMKSPEIbTSnuhNoNA0/0YnM6V55owcVrp6XINNIuLwfRz863mENtmIeF66I3NNsfOICCA+eqGWqDtKtL0NEDaHBu1VJK6sLN5DP4GyDMzcUdHP3BDoOo7bq941HfShVAbzok9wRzr8hOuj0YfDh9m8QuQN8PHPMjIwgAAAABJRU5ErkJggg=="
                    />
                    <p>{t('myaccount.myOrders.offerExpiredMessage')}</p>
                </div>
            </div>
        );
    }
    if (mySavedDeal.fullProductConfiguration.stock && !mySavedDeal.fullProductConfiguration.availability) {
        return (
            <div className="overlay">
                <div className="dialog">
                    <h1>{t('stockVehicleUnavailable.title')}</h1>
                    <p className="unavailableVehicleDescription">
                        <span>{t('stockVehicleUnavailable.label')}</span>
                        <span className="unavailableVehicleRedirect" onClick={unavailableVehicleRedirect}>
                            {t('stockVehicleUnavailable.button')}
                        </span>
                    </p>
                </div>
            </div>
        );
    }
};
